import Service from '@/service/index.js';
export default {
  components: {
  },
  props: ['projectInfo', 'userInfo', 'transfereeInfo'],
  data() {
    return {
      managementSubjectCodeArr: [],
      transferTypeArr: [],
      payTypeArr: [],
      circulationTypeCodeArr: [],
      bidTypeArr: [],
      projectPurposeArr: [],
      contractorPriorityCodeArr: [],
      tradeTypeArr: [],
      type1: ['1-1', '1-2', '3-1', '4-1', '4-2', '4-3', '4-4'],
      type2: ['2-1', '2-2', '2-3'],
      type3: ['6-1', '7-1', '7-2'],
      type4: ['2-1', '2-3'],
      landtypeArr: []
    };
  },
  created() {
    const obj = {
      MANAGEMENT_SUBJECT: 'managementSubjectCodeArr',
      TRANSFER_TYPE: 'transferTypeArr',
      PAY_TYPE: 'payTypeArr',
      CIRCULATION_TYPE: 'circulationTypeCodeArr',
      BIDDING_METHOD: 'bidTypeArr',
      PROJECT_PURPOSE: 'projectPurposeArr',
      CONTRACTOR_PRIORITY: 'contractorPriorityCodeArr',
      TRADE_TYPE: 'tradeTypeArr',
      LAND_CATEGORY: 'landtypeArr'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
  },
  computed: {
    unBidSelText () {
      const str = this.projectInfo && this.projectInfo.addressDetail;
      if (str) {
        return str.split(' ').slice(1).join('');
      }
      return '';
    },
    projectCode() {
      if(this.projectInfo && this.projectInfo.projectType && this.projectInfo.projectSubType) {
        return `${this.projectInfo.projectType}-${this.projectInfo.projectSubType}`;
      }
    }
  }
};
